<template>
  <v-container class="pa-0">
    <v-row>
      <v-col cols="12" md="12">
        <v-text-field
          label="IBAN"
          ref="accountNumber"
          v-model="accountNumber"
          placeholder="XX000000000000000000"
          :rules="[() => !!accountNumber || 'This field is required']"
          @input="handleInput"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { formValidation } from '../../mixins/validation.mixins';

export default {
  mixins: [formValidation],
  props: {
    value: {
      type: Object,
    },
  },
  data() {
    return {
      accountNumber: this.value.accountNumber,
    };
  },
  methods: {
    handleInput() {
      this.$emit('input', {
        routingNumber: '',
        accountNumber: this.accountNumber,
      });
    },
  },
};
</script>
